import { FC, ReactNode, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

interface KioskAuthGuardProps {
    children: ReactNode;
}

const KioskAuthGuard: FC<KioskAuthGuardProps> = ({ children }) => {
    const navigate = useNavigate();
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
    const isPhoneVerified = localStorage.getItem("isPhoneVerified") === "true";

    useEffect(() => {
        if(isLoggedIn) {
            if(!isPhoneVerified) navigate('/verify');
            else navigate('/home');
        }
        else {
            navigate('/login');
        }
    },[isPhoneVerified]);


  // If user is logged in, allow access to secure pages
    if (isLoggedIn) {    
        return <>{children}</>;
    } 

  // If user is not logged in, redirect to login page
  return <Navigate to="/login" replace />;
};

export default KioskAuthGuard;
